











































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeNavigationStore from '@/components/Backoffice/NavBar/Store/BackofficeNavigationStore'
import { permissionService } from '@/services/permission.service'
import AprovacaoApi from '@/Apis/Agendamento/Services/AprovacaoApi'

@Component
export default class ComponentBackofficeLeftNavBar extends Vue {
  items: any[] = [
    {
      title: 'Fidelização',
      icon: 'las la-handshake',
      url: '/backoffice/fidelizacao',
      view: 'operadora-fidelizacao',
    },
    {
      title: 'Equipe Médica',
      icon: 'las la-first-aid',
      externalUrl: '/v2/backoffice/equipe-medica',
      view: '',
      permissao: 'agendamento.backoffice.equipeMedica.listar',
    },
    {
      title: 'Agendamento',
      icon: 'menu_book',
      url: '/backoffice/agendamento',
      view: 'backoffice-agendamento',
    },
    {
      title: 'Suprimentos',
      icon: 'mdi-medical-bag',
      url: '/backoffice/suprimentos',
      view: 'backoffice-suprimentos',
    },
    {
      title: 'Agência Transfusional',
      icon: 'mdi-iv-bag',
      url: '/backoffice/agencia-transfusional',
      view: 'backoffice-agencia-transfusional',
    },
    {
      title: 'Autorização',
      icon: 'mdi-format-list-checks',
      url: '/backoffice/autorizacao',
      view: 'backoffice-autorizacao',
    },
    {
      title: 'Orçamento',
      icon: 'mdi-account-cash',
      url: '/backoffice/orcamento',
      view: 'backoffice-orcamento',
    },
    {
      title: 'Farmácia',
      icon: 'las la-pills',
      url: '/backoffice/farmacia',
      view: 'backoffice-farmacia',
    },
    {
      title: 'Regulação',
      icon: 'las la-gavel',
      url: '/backoffice/regulacao',
      view: 'backoffice-regulacao',
      permissao: 'agendamento.backoffice.regulacao.listar',
    },
    {
      title: 'Operadora / Convênio',
      icon: 'las la-hand-holding-usd',
      url: '/backoffice/operadora-convenio',
      view: 'backoffice-operadora-convenio',
      permissao: 'agendamento.backoffice.fidelizacao.editarOperadoraConvenio',
    },
    {
      title: 'Consulta Pré-anestésico',
      icon: 'mdi-needle',
      url: '/backoffice/pre-anestesico',
      view: 'backoffice-pre-anestesico',
    },
    {
      title: 'Bate mapa',
      icon: 'mdi-clipboard-pulse-outline',
      url: '/backoffice/mapa-cirurgico',
      view: 'backoffice-mapa-cirurgico',
    },
    {
      title: 'Mapa cirúrgico',
      icon: 'las la-sitemap',
      url: '/backoffice/mapa-cirurgico-grade',
      view: 'backoffice-mapa-cirurgico-grade',
    },
    {
      title: 'Cadastro Médico',
      icon: 'mdi-clipboard-list-outline',
      url: '/backoffice/cadastro-medico',
      view: 'backoffice-cadastro-medico',
    },
    {
      title: 'Chat',
      icon: 'las la-comments',
      url: '/backoffice/chat',
      view: 'backoffice-chat',
    },
    {
      title: 'Notificações',
      icon: 'notification_important',
      url: '/backoffice/notificacoes',
      view: 'backoffice-notificacoes',
    },
    {
      title: 'Tempo cirúrgico',
      icon: 'las la-stopwatch',
      url: '/backoffice/tempo-cirurgico-por-procedimento',
      view: 'backoffice-tempo-cirurgico-por-procedimento',
    },
    {
      title: 'Recusa de orçamento',
      icon: 'mdi-cash-remove',
      url: '/backoffice/motivo-recusa-orcamento',
      view: 'backoffice-motivo-recusa-orcamento',
    },
    {
      title: 'Comorbidades',
      icon: 'mdi-account-heart-outline',
      url: '/backoffice/comorbidades',
      view: 'backoffice-comorbidades',
    },
    {
      title: 'Portal do Médico',
      icon: 'mdi-hospital-box-outline',
      url: '/agendamento-medico',
      view: 'agendamento-medico',
    },
    {
      title: 'Produção',
      icon: 'add_box',
      url: '/backoffice/producao',
      view: 'backoffice-producao',
    },
    {
      title: 'BI',
      icon: 'las la-chart-bar',
      url: '/backoffice/power-bi',
      view: 'backoffice-power-bi',
    },
    {
      title: 'Protocolo',
      icon: 'las la-medal',
      externalUrl: '/v2/backoffice/protocolo',
      view: '',
      permissao: 'agendamento.backoffice.protocolo.listar',
    },
    {
      title: 'Materiais',
      icon: 'las la-syringe',
      externalUrl: '/v2/backoffice/material',
      view: '',
      permissao: 'agendamento.backoffice.opmeTabelaPropria.listar',
    },
    {
      title: 'Aprovação',
      icon: 'las la-check',
      externalUrl: '/v2/backoffice/aprovacao',
      view: '',
      permissao: 'agendamento.backoffice.fluxoDeAprovacao.listar',
      badgeKey: 'aprovacao',
    },
    {
      title: 'Doc. Obrigatória',
      icon: 'las la-file-alt',
      externalUrl: '/v2/backoffice/documentacao-obrigatoria',
      view: '',
      permissao: 'agendamento.backoffice.documentacaoObrigatoria.listar',
    },
    {
      title: 'Regras de reserva',
      icon: 'las la-calendar',
      url: '/backoffice/configuracao-de-sala',
      view: 'backoffice-configuracao-de-sala',
    },
    {
      title: 'Procedimento Hospital Dia',
      icon: 'las la-book-medical',
      url: '/backoffice/procedimento-hospital-dia',
      view: 'backoffice-procedimento-hospital-dia',
    },
    // {
    //   title: 'Carga Logs',
    //   icon: 'mdi-file-alert-outline',
    //   url: '/financeiro-carga-logs',
    //   view: 'financeiro',
    // },
    {
      title: 'Chat',
      icon: 'las la-comments',
      url: '/financeiro-backoffice/chat',
      view: 'backoffice-chat-remuneracao',
    },
    {
      title: 'Recebimento monitor',
      icon: 'mdi-monitor-dashboard',
      url: '/recebimento-monitor',
      view: 'remuneracao-monitor',
    },
  ]

  configItems: any[] = [
    {
      title: 'Usuários',
      icon: 'la la-user-alt',
      url: '/configuracoes/usuarios',
      view: 'configuracao-usuarios',
      keyAuthorized: 'solicitacao-cirurgia',
    },
    {
      title: 'Pessoas',
      icon: 'las la-user-friends',
      url: '/configuracoes/pessoa',
      view: 'configuracao-pessoa',
      keyAuthorized: 'solicitacao-cirurgia',
    },
    {
      title: 'Solicitação de cirurgia',
      icon: 'la la-file-alt',
      url: '/configuracoes/solicitacao-cirurgia',
      view: 'configuracao-solicitacao-cirurgia',
      keyAuthorized: 'solicitacao-cirurgia',
    },
    {
      title: 'Integração Operadora',
      icon: 'mdi-lan-connect',
      url: '/configuracoes/integracao-operadora',
      view: 'configuracao-integracao-operadora',
      keyAuthorized: 'solicitacao-cirurgia',
    },
  ]

  calculoItems: any[] = [
    {
      title: 'Geração de repasse',
      icon: 'las la-chart-bar',
      url: '/financeiro-geracao-de-repasse',
      view: 'financeiro-geracao-de-repasses',
      keyAuthorized: 'financeiro-geracao-de-repasses',
    },
    {
      title: 'Integração Geral de Repasses',
      icon: 'mdi-clipboard-list-outline',
      url: '/integracao-geral-repasses',
      view: 'integracao-geral-repasses',
      keyAuthorized: 'financeiro-integracao-geral-repasses',
    },
    {
      title: 'Produção disponível',
      icon: 'mdi-clipboard-list-outline',
      url: '/financeiro-producao-disponivel-calculo',
      view: 'financeiro-producao-disponivel-calculo',
      keyAuthorized: 'financeiro-geracao-de-repasses',
    },
    {
      title: 'Garantia mínima global',
      icon: 'mdi-cash-multiple',
      url: '/financeiro-garantia-minima-global',
      view: 'financeiro-garantia-minima-global',
      keyAuthorized: 'financeiro-calculo-garantia-minima-global',
    },
    {
      title: 'Calculo teto',
      icon: 'mdi-finance',
      url: '/financeiro-calculo-teto',
      view: 'financeiro-calculo-teto',
      keyAuthorized: 'financeiro-calculo-teto-global',
    },
    {
      title: 'Calculo validação',
      icon: 'la-list-alt',
      url: '/financeiro-calculo-remuneracao',
      view: 'backoffice-calculo-validacao',
      keyAuthorized: 'backoffice-calculo-validacao',
    },
    {
      title: 'Recalcular procedimentos',
      icon: 'la-list-alt',
      url: '/financeiro-recalcular-procedimentos',
      view: 'financeiro-recalcular-procedimentos',
      keyAuthorized: 'financeiro-recalcular-procedimentos',
    },
    {
      title: 'Regras de cálculo',
      icon: 'la-stream',
      url: '/financeiro-regras-calculo',
      view: 'backoffice-calculo-regra-profissional',
      keyAuthorized: 'backoffice-calculo-regra-profissional',
    },
    {
      title: 'Transação financeira',
      icon: 'la-money-bill',
      url: '/financeiro-transacao-financeira',
      view: 'financeiro-transacao-financeira',
      keyAuthorized: 'financeiro',
    },
    {
      title: 'Centro de custo',
      icon: 'la-sitemap',
      url: '/financeiro-centro-de-custo',
      view: 'financeiro-centro-de-custo',
      keyAuthorized: 'financeiro',
    },
    {
      title: 'Mapeamento Operadora',
      icon: 'la-hospital',
      url: '/financeiro-operadora-hospital',
      view: 'financeiro-operadora-hospital',
      keyAuthorized: 'financeiro',
    },
    {
      title: 'Agenda garantia mínima',
      icon: 'la-handshake',
      url: '/financeiro-agenda-minima-garantia-periodo',
      view: 'financeiro-agenda-minima-garantia-periodo',
      keyAuthorized: 'financeiro-agenda-minima-garantia-periodo',
    },
    {
      title: 'Tabela de feriados',
      icon: 'la-calendar-alt',
      url: '/financeiro-tabela-feriados',
      view: 'financeiro-tabela-feriados',
      keyAuthorized: 'financeiro-feriado',
    },
    {
      title: 'Tabela Amb',
      icon: 'la-table',
      url: '/financeiro-tabela-amb',
      view: 'backoffice-calculo-tabela-ambtuss',
      keyAuthorized: 'backoffice-calculo-tabela-ambtuss',
    },
    {
      title: 'Tabela preço',
      icon: 'las la-coins',
      url: '/financeiro-tabela-preco',
      view: 'financeiro-tabela-preco',
      keyAuthorized: 'financeiro-tabela-propria',
    },
    {
      title: 'Monitor de integração',
      icon: 'las la-project-diagram',
      url: '/financeiro-monitor-integracao',
      view: 'financeiro-monitor-integracao',
      keyAuthorized: 'financeiro-monitor-integracao',
    },
    {
      title: 'Tabela de pontuacao',
      icon: 'las la-file-invoice',
      url: '/financeiro-tabela-pontuacao',
      view: 'financeiro-tabela-senioridade',
      keyAuthorized: 'financeiro-tabela-senioridade',
    },
    {
      title: 'Pontuação profissional',
      icon: 'mdi-scoreboard-outline',
      url: '/financeiro-pontuacao-profissional',
      view: 'financeiro-pontuacao-profissional',
      keyAuthorized: 'financeiro-pontuacao-profissional',
    },
    {
      title: 'Taxa de aluguel',
      icon: 'mdi-bank-transfer',
      url: '/financeiro-taxa-aluguel',
      view: 'financeiro-taxa-aluguel',
      keyAuthorized: 'financeiro-taxa-aluguel',
    },
    {
      title: 'Cadastro vínculo relatório',
      icon: 'mdi-chart-box-plus-outline',
      url: '/financeiro-relatorio-perfil',
      view: 'financeiro-relatorio-perfil',
      keyAuthorized: 'financeiro-relatorio-perfil',
    },
    {
      title: 'Tabelas de Referência',
      icon: 'las la-table',
      url: '/backoffice/tabelas-referencia',
      view: 'calculo-tabela-referencia',
      keyAuthorized: 'backoffice-calculo-tabela-referencia',
    },
    {
      title: 'Imposto Prestador',
      icon: 'mdi-account-plus',
      url: '/financeiro-imposto-prestador',
      view: 'financeiro-imposto-prestador',
      keyAuthorized: 'financeiro-imposto-prestador',
    },
    {
      title: 'Gerenciar Equipes',
      icon: 'mdi-account-group-outline',
      url: '/financeiro-gerenciamento-equipes',
      view: 'financeiro-gerenciamento-equipes',
      keyAuthorized: 'financeiro-gerenciamento-equipes',
    },
    {
      title: 'Especialidades',
      icon: 'mdi-clipboard-list-outline',
      url: '/financeiro-especialidade',
      view: 'financeiro-especialidade',
      keyAuthorized: 'financeiro-especialidade',
    },
  ]

  notaFiscalItems: any[] = [
    {
      title: 'Financeiro',
      icon: 'mdi-cash-multiple',
      url: '/financeiro',
      view: 'financeiro',
      keyAuthorized: 'financeiro',
    },
    {
      title: 'Notificar',
      icon: 'mdi-bell-ring',
      url: '/financeiro-notificar-email',
      view: 'financeiro-notificar-email',
      keyAuthorized: 'financeiro-notificar-email',
    },
    {
      title: 'Cadastro layout de email',
      icon: 'mdi-email-multiple-outline',
      url: '/financeiro-cadastro-layout-email',
      view: 'financeiro-cadastro-layout-email',
      keyAuthorized: 'financeiro-cadastro-layout-email',
    },
    {
      title: 'Download',
      icon: 'las la-download',
      url: '/financeiro-download-notas',
      view: 'financeiro-download-notas',
      keyAuthorized: 'financeiro-download-notas',
    },
    {
      title: 'Carga via planilha',
      icon: 'mdi-file-upload',
      url: '/financeiro-carga-remuneracao',
      view: 'financeiro-carga-remuneracao',
      keyAuthorized: 'financeiro-carga-remuneracao',
    },
    {
      title: 'Contratos',
      icon: 'library_books',
      url: '/backoffice/contratos',
      view: 'backoffice-contratos',
      keyAuthorized: 'backoffice-contratos',
    },
  ]

  suporteFinanceiro: any[] = [
    {
      title: 'Usuários',
      icon: 'las la-user-circle',
      externalUrl: '/v2/remuneracao/backoffice/cadastro-usuario',
      view: '',
      permissao: 'remuneracao.cadastro.usuario.listar',
    },
    {
      title: 'Consulta cadastral',
      icon: 'mdi-account-search-outline',
      externalUrl: '/v2/remuneracao/backoffice/consulta-cadastral',
      view: '',
      keyAuthorized: 'consulta-cadastral',
    },
  ]

  suporteFinanceiroAdmin: any[] = [
    {
      title: 'Grupo Hospital',
      icon: 'la la-hospital',
      url: '/financeiro/cadastro/grupo-hospital',
      view: 'financeiro-cadastro-grupo-hospital',
      keyAuthorized: 'financeiro-adm-hospitais',
    },
    {
      title: 'Contratos',
      icon: 'mdi-note-text-outline',
      url: '/suporte/contratos',
      view: 'suporte-contratos',
      keyAuthorized: 'financeiro-suporte-contratos',
    },
    {
      title: 'Usuários',
      icon: 'las la-user-circle',
      url: '/suporte/usuarios',
      view: 'suporte-usuarios',
      keyAuthorized: 'financeiro-suporte-usuarios',
    },
    {
      title: 'Grupo de repasses',
      icon: 'las la-wallet',
      url: '/suporte/grupo-repasses',
      view: 'suporte-grupo-repasses',
      keyAuthorized: 'financeiro-suporte-grupo-repasses',
    }
  ]

  antecipacaoRecebiveisItems: any[] = [
    {
      title: 'Antecipação de recebíveis',
      icon: 'mdi-cash-clock',
      url: '/financeiro-antecipacao-recebiveis',
      view: 'financeiro-antecipacao-recebiveis',
      keyAuthorized: 'financeiro-antecipacao-recebiveis',
    },
  ]

  suporteItems: any[] = [
    {
      title: 'Hospitais',
      icon: 'la la-hospital',
      url: '/suporte/hospitais',
      view: 'suporte-hospitais',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Pacientes',
      icon: 'mdi-account-injury-outline',
      url: '/suporte/pacientes',
      view: 'suporte-pacientes',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Secretárias',
      icon: 'mdi-account-tie-woman',
      url: '/suporte/secretarias',
      view: 'suporte-secretarias',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Convites',
      icon: 'mdi-email-seal-outline',
      url: '/suporte/convites',
      view: 'suporte-convites',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Procedimentos',
      icon: 'mdi-medication-outline',
      url: '/suporte/procedimentos',
      view: 'suporte-procedimentos',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Convênios',
      icon: 'las la-laptop-medical',
      url: '/suporte/convenios',
      view: 'suporte-convenios',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Tipo de acomodação',
      icon: 'mdi-bed-outline',
      url: '/suporte/tipo-acomodacao',
      view: 'suporte-tipo-acomodacao',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Procedimentos Hospital Dia',
      icon: 'las la-hand-holding-heart',
      url: '/suporte/procedimentos-apenas-hospital-dia',
      view: 'suporte-procedimentos-apenas-hospital-dia',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Equipamentos',
      icon: 'mdi-hammer-screwdriver',
      url: '/suporte/equipamentos',
      view: 'suporte-equipamentos',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Fornecedores',
      icon: 'mdi-truck-fast',
      url: '/suporte/fornecedores',
      view: 'suporte-fornecedores',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Caixas cirúrgicas',
      icon: 'las la-briefcase-medical',
      url: '/suporte/caixas-cirurgicas',
      view: 'suporte-caixas-cirurgicas',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Anestesistas',
      icon: 'las la-syringe',
      url: '/suporte/anestesistas',
      view: 'suporte-anestesistas',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Países',
      icon: 'mdi-flag-variant-outline',
      url: '/suporte/paises',
      view: 'suporte-paises',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Salas e centros cirúrgicos',
      icon: 'mdi-hospital-box-outline',
      url: '/suporte/salas-centros-cirurgicos',
      view: 'suporte-salas-centros-cirurgicos',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Situação de solicitação',
      icon: 'las la-redo-alt',
      url: '/suporte/alterar-situacao-solicitacao',
      view: 'suporte-alterar-situacao-solicitacao',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Motivo de Cancelamento',
      icon: 'mdi-file-cancel-outline',
      url: '/suporte/motivo-cancelamento',
      view: 'suporte-motivo-cancelamento',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Motivo de Transferência',
      icon: 'mdi-file-arrow-left-right-outline',
      url: '/suporte/motivo-transferencia-reserva',
      view: 'suporte-motivo-transferencia-reserva',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Atualização de PDF',
      icon: 'las la-file-pdf',
      url: '/suporte/atualizacao-de-pdf',
      view: 'suporte-atualizacao-de-pdf',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Salas de Robótica',
      icon: 'mdi-robot-outline',
      url: '/suporte/salas-roboticas',
      view: 'suporte-salas-roboticas',
      keyAuthorized: 'suporte',
    },
    {
      title: 'Limitador de Cirurgia',
      icon: 'mdi-calendar-lock',
      externalUrl: '/v2/backoffice/suporte/limitador-cirurgia',
      permissao: 'agendamento.backoffice.suporte.limitadorCirurgia.listar',
      view: '',
    },
    {
      title: 'Feedback',
      icon: 'mdi-comment-quote-outline',
      url: '/suporte/feedback',
      view: 'suporte-feedback',
      keyAuthorized: 'suporte',
    },
  ]

  allowedItems: string[] = []

  get menu() {
    return this.items.filter((e: any) => this.allowedItems.includes(e.view) || this.allowedItems.includes(e.permissao))
  }

  get suporteFinanceiroItems() {
    return this.suporteFinanceiro.filter((e: any) => this.allowedItems.includes(e.view) || this.allowedItems.includes(e.permissao) || this.allowedItems.includes(e.keyAuthorized))
  }

  get antecipacaoItems() {
    return this.antecipacaoRecebiveisItems.filter((e: any) => this.allowedItems.includes(e.keyAuthorized))
  }

  get suporteFinanceiroAdminItems() {
    return this.suporteFinanceiroAdmin.filter((e: any) => this.allowedItems.includes(e.view) || this.allowedItems.includes(e.permissao) || this.allowedItems.includes(e.keyAuthorized))
  }

  get subMenu() {
    return this.configItems.filter((e: any) => this.allowedItems.includes(e.keyAuthorized))
  }

  get subMenuCalculo() {
    return this.calculoItems.filter((e: any) => this.allowedItems.includes(e.keyAuthorized))
  }

  get subMenuNotaFiscal() {
    return this.notaFiscalItems.filter((e: any) => this.allowedItems.includes(e.keyAuthorized))
  }

  get getBackofficeNavigationStore() {
    return getModule(BackofficeNavigationStore, this.$store)
  }

  get launcher() {
    return this.$vuetify.breakpoint.md || this.drawer
  }

  set launcher(value: boolean | null) {
    this.getBackofficeNavigationStore.setNavigationDrawer(value)
  }

  get drawer() {
    return this.getBackofficeNavigationStore.navigationDrawer
  }

  set drawer(value: boolean | null) {
    this.getBackofficeNavigationStore.setNavigationDrawer(value)
  }

  get mini() {
    if (this.$vuetify.breakpoint.smAndDown) this.miniSync = false
    return this.miniSync
  }

  set mini(value: boolean) {
    this.miniSync = value
  }

  get miniSync() {
    return this.getBackofficeNavigationStore.miniSync
  }

  set miniSync(value: boolean) {
    this.getBackofficeNavigationStore.setMiniSync(value)
  }

  badge = {
    aprovacao: 0,
  }

  shouldShowBadge(item) {
    const result = item.badgeKey && this.badge[item.badgeKey] > 0
    return result
  }

  async getBadgeValue() {
    if (permissionService.hasPermission('agendamento.backoffice.fluxoDeAprovacao.listar')) {
      const request = await AprovacaoApi.getBadgeValue()
      this.badge.aprovacao = request.data.quantidade
    }
  }

  navigateToOtherAppByLink(link: string) {
    if (link) {
      window.location.pathname = link
    }
  }

  created() {
    const allowedPageAuthorized = this.$user.profile.pageAuthorized ? Object.values<string>(this.$user.profile.pageAuthorized) : []
    const allowedPermissions = this.$user.profile.permissoes ? Object.values<string>(this.$user.profile.permissoes) : []
    this.allowedItems = allowedPageAuthorized.concat(allowedPermissions)
    this.getBadgeValue()
  }
}
